import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67926df6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { temp: "g" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "detail-item" }
const _hoisted_4 = { class: "detail-item" }
const _hoisted_5 = {
  key: 0,
  class: "flex"
}
const _hoisted_6 = { class: "detail-item" }
const _hoisted_7 = { class: "detail-item" }
const _hoisted_8 = { class: "detail-item" }
const _hoisted_9 = { class: "flex" }
const _hoisted_10 = { class: "detail-item" }
const _hoisted_11 = {
  key: 0,
  class: "detail-item"
}
const _hoisted_12 = { class: "detail-item" }
const _hoisted_13 = { class: "detail-item" }
const _hoisted_14 = { class: "detail-item" }
const _hoisted_15 = { class: "flex" }
const _hoisted_16 = { class: "detail-item" }
const _hoisted_17 = { class: "detail-item" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "detail-item" }
const _hoisted_21 = { class: "detail-item" }
const _hoisted_22 = { class: "detail-item" }
const _hoisted_23 = { class: "table" }
const _hoisted_24 = { class: "table-thead" }
const _hoisted_25 = { class: "table-body" }
const _hoisted_26 = ["src"]
const _hoisted_27 = { style: {"text-align":"right"} }
const _hoisted_28 = { class: "flex-cen-fdc" }
const _hoisted_29 = { class: "flex-wrap volumePop" }
const _hoisted_30 = { class: "volumePopTitle" }
const _hoisted_31 = { class: "volumePopTitle" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "0～40cm", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "41～60cm", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "61～100cm", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "101～140cm", -1))
const _hoisted_36 = { class: "volumeHead-tips" }
const _hoisted_37 = { class: "flex-cen-fdc" }
const _hoisted_38 = {
  key: 0,
  class: "flex-cen-fdc",
  style: {"padding":"10px 10px","max-width":"300px"}
}
const _hoisted_39 = { class: "text-ct rulesTitle" }
const _hoisted_40 = { class: "flex-col text-rt rulesItem" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = { style: {"color":"#EA6963"} }
const _hoisted_44 = {
  key: 1,
  class: "flex-cen-fdc",
  style: {"padding":"10px 30px","max-width":"300px"}
}
const _hoisted_45 = { class: "text-ct rulesTitle" }
const _hoisted_46 = { class: "flex-bwn" }
const _hoisted_47 = { class: "flex-col text-rt rulesItem" }
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { key: 1 }
const _hoisted_50 = { class: "flex-bwn" }
const _hoisted_51 = { class: "flex-col text-rt rulesItem" }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = { key: 1 }
const _hoisted_54 = { class: "volumeHead-tips" }

import { t } from '@/plugins/i18n'
import { ref, reactive, computed } from 'vue'
import { getJapanTime } from '@/util/common'
import { formatPrice, plusPrice, reducePrice, setFixed2 } from './data'
import STable from '@/components/Table/index.vue'
import TableButton from '@/components/Table/TableButton.vue'
import { getBillInfoExport } from '@/apis/fund'
import { Warning } from '@element-plus/icons-vue'
import ShoppingPreview from '@/components/common/ShoppingPreview.vue'
import { ElMessage } from 'element-plus'
import dayjs from 'dayjs'
import { isEN, isMultiStore } from '@/store'
import { showCurrentUnit } from '@/util/useYan'

export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  rowName: {
    type: String,
    default: ''
  },
  rowItemDetail: {
    type: Object,
    default: () => ({})
  },
  type: {
    type: Number,
    default: 1
  }
},
  setup(__props) {

const props = __props


const volumeMap = {
  XS: t('超小'),
  S: t('小'),
  M: t('中'),
  L: t('大'),
  XL: t('超大')
} as const

const productColumns1 = [
  { prop: 'productImg', label: t('商品图片') },
  { prop: 'productSku', label: t('平台商品SKU') },
  { prop: 'customerProductSku', label: t('客户商品SKU') },
  { prop: 'productPropertiesName', label: t('规格') },
  // { prop: 'productTitle', label: t('商品信息') },
  { prop: 'settlePrice', label: t('单价') },
  { prop: 'num', label: t('数量') },
  { prop: 'settleMoney', label: t('总价') }
]

const productColumns2 = [
  { prop: 'productImg', label: t('商品图片') },
  { prop: 'productSku', label: t('平台商品SKU') },
  { prop: 'customerProductSku', label: t('客户商品SKU') },
  // { prop: 'productTitle', label: t('商品信息') },
  { prop: 'price', label: t('单价') },
  { prop: 'num', label: t('数量') },
  { prop: 'createTime', label: t('扣费日') },
  { prop: 'lastDeductionDate', label: t('上次扣费日') },
  { prop: 'shelfTime', label: t('上架日') },
  { prop: 'freeDay', label: t('免费保管天数') },
  { prop: 'days', label: t('计费天数') },
  { prop: 'money', label: t('总价') }
]

const columns = [
  {
    label: t('商品图片'),
    prop: 'skuImg',
    align: 'center',
    slotName: 'skuImg'
  },
  {
    label: t('商品SKU'),
    prop: 'skuCode',
    align: 'center'
  },
  {
    label: t('上架日'),
    prop: 'date',
    align: 'center',
    slotName: 'date'
  },
  {
    label: t('总计天数'),
    prop: 'thisSettleNum',
    align: 'center',
    width: 120
  },
  {
    label: t('免费保管天数'),
    prop: 'thisFreeNum',
    align: 'center',
    width: 120
  },
  {
    label: t('需计费天数'),
    prop: 'thisActSettleNum',
    align: 'center',
    width: 120
  },
  {
    label: t('体积类型'),
    prop: 'volume',
    align: 'center',
    slotHeadName: 'volumeHead',
    slotName: 'volume'
  },
  {
    label: t('单价'),
    prop: 'settlePrice',
    align: 'center',
    slotHeadName: 'settleHead',
    slotName: 'settlePrice',
    width: 140
  },
  {
    label: t('数量'),
    prop: 'nums',
    align: 'center',
    slotName: 'nums'
  },
  {
    label: t('总价'),
    prop: 'settleAmt',
    align: 'center',
    slotName: 'settleAmt'
  }
]

const columnsRetention = [
  {
    label: t('发货单编号'),
    prop: 'deliverCode',
    align: 'center',
    width: 150
  },
  {
    label: t('滞留日期'),
    prop: 'date',
    align: 'center'
  },
  {
    label: t('发货完成日期'),
    prop: 'deliverDate',
    align: 'center',
    slotName: 'deliverDate'
  },
  {
    label: t('总计天数'),
    prop: 'thisSettleNum',
    align: 'center',
    width: 120
  },
  {
    label: t('免费滞留天数'),
    prop: 'thisFreeNum',
    align: 'center',
    width: 120
  },
  {
    label: t('需计费天数'),
    prop: 'thisActSettleNum',
    align: 'center',
    width: 120
  },
  {
    label: t('计费类型'),
    prop: 'pkgType',
    align: 'center',
    slotName: 'pkgType'
  },
  {
    label: t('单价'),
    prop: 'settlePrice',
    align: 'center',
    slotHeadName: 'settleHead',
    slotName: 'settlePrice',
    width: 140
  },
  {
    label: `${t('数量')}(${t('体积')})`,
    prop: 'nums',
    align: 'center',
    slotName: 'nums'
  },
  {
    label: t('总价'),
    prop: 'settleAmt',
    align: 'center',
    slotName: 'settleAmt'
  }
]

// 币种是否为韩元
const isKrwCurrencyCode = computed(() => {
  return isMultiStore() && props.rowItemDetail?.currencyCode === 'KRW'
})

const loading = ref(false)
const downLoad = () => {
  loading.value = true
  getBillInfoExport({
    billNo: props.rowItemDetail.billNo
  }).then(res => {
    const blob = new Blob([res], { type: 'application/vnd.ms-excel' })
    // const fileName = props.rowItemDetail.billNo + ' ' + dayjs().format('YYYY-MM-DD')
    const fileName = props.rowItemDetail.bizContentCustomer + ' ' + props.rowItemDetail.settleDate
    const objectUrl = URL.createObjectURL(blob)
    const a = document.createElement('a')
    document.body.appendChild(a)
    a.setAttribute('style', 'display:none')
    a.setAttribute('href', objectUrl)
    a.setAttribute('download', fileName)
    a.click()
    URL.revokeObjectURL(objectUrl)
    ElMessage.success(t('导出成功'))
  }).finally(() => {
    loading.value = false
  })
}


return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createBlock(_component_el_scrollbar, { height: "550px" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)('费用类型')) + "：", 1),
            _createElementVNode("span", null, _toDisplayString(__props.rowName) + " (" + _toDisplayString(__props.rowItemDetail?.bizContentCustomer) + ")", 1)
          ]),
          _createElementVNode("p", _hoisted_4, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)('可用余额')) + "：", 1),
            _createElementVNode("span", null, _toDisplayString(_unref(formatPrice)(__props.rowItemDetail?.afterAvailableAmount)) + _toDisplayString(_unref(showCurrentUnit)(_unref(isKrwCurrencyCode))), 1)
          ])
        ]),
        ([28, 76].includes(__props.rowItemDetail?.fundFlowDetailType))
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, [
                _createElementVNode("span", null, _toDisplayString(_unref(t)('结算总价')) + "：", 1),
                _createElementVNode("span", null, "-" + _toDisplayString(__props.rowItemDetail?.actSettleAmt) + _toDisplayString(_unref(showCurrentUnit)(_unref(isKrwCurrencyCode))), 1)
              ]),
              _createElementVNode("p", _hoisted_7, [
                _createElementVNode("span", null, _toDisplayString(_unref(t)('结算周期')) + "：", 1),
                _createElementVNode("span", null, _toDisplayString(__props.rowItemDetail?.startDate) + " - " + _toDisplayString(__props.rowItemDetail?.endDate), 1)
              ]),
              _createElementVNode("p", _hoisted_8, [
                _createElementVNode("span", null, _toDisplayString(_unref(t)('日期')) + "：", 1),
                _createElementVNode("span", null, _toDisplayString(__props.rowItemDetail?.actSettleTime ? _unref(getJapanTime)(__props.rowItemDetail?.actSettleTime) : ''), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (__props.rowItemDetail?.fundFlowDetailType === 2)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("p", _hoisted_10, [
                  _createElementVNode("span", null, _toDisplayString(_unref(t)('寻源单编号')) + "：", 1),
                  _createElementVNode("span", null, _toDisplayString(__props.rowItemDetail?.orderNo), 1)
                ]),
                (__props.rowItemDetail.fundFlowNo)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_11, [
                      _createElementVNode("span", null, _toDisplayString(_unref(t)('流水号')) + "：", 1),
                      _createElementVNode("span", null, _toDisplayString(__props.rowItemDetail.fundFlowNo), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("p", _hoisted_12, [
                  _createElementVNode("span", null, _toDisplayString(_unref(t)('日期')) + "：", 1),
                  _createElementVNode("span", null, _toDisplayString(__props.rowItemDetail?.createTime ? _unref(getJapanTime)(__props.rowItemDetail?.createTime) : ''), 1)
                ])
              ]),
              _createElementVNode("p", _hoisted_13, [
                _createElementVNode("span", null, _toDisplayString(_unref(t)('商品名称')) + "：", 1),
                _createElementVNode("span", null, _toDisplayString((__props.rowItemDetail?.customerWalletFundFlowOrderDTO?.customerWalletFundFlowGoodsDTOList ?? []).map((e) => _unref(t)(e.productTitle)).join(',')), 1)
              ]),
              _createElementVNode("p", _hoisted_14, [
                _createElementVNode("span", null, _toDisplayString(_unref(t)('结算总价')) + "：", 1),
                _createElementVNode("span", null, _toDisplayString(_unref(reducePrice)(_unref(setFixed2)((__props.rowItemDetail?.customerWalletFundFlowOrderDTO?.customerWalletFundFlowGoodsDTOList ??
              []).reduce((total, v) => total + (v.settleMoney ?? 0), 0)))) + _toDisplayString(_unref(showCurrentUnit)(_unref(isKrwCurrencyCode))), 1)
              ])
            ], 64))
          : _createCommentVNode("", true),
        ([3, 4, 5, 6, 7, 8, 10, 31, 32, 68, 88, 89].includes(__props.rowItemDetail?.fundFlowDetailType))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("p", _hoisted_16, [
                  _createElementVNode("span", null, _toDisplayString([7, 8].includes(__props.rowItemDetail?.fundFlowDetailType) ? _unref(t)('订单编号') : __props.rowItemDetail?.fundFlowDetailType
              === 32 ? _unref(t)('发货单号') : _unref(t)('THE CKB订单编号')) + "：", 1),
                  _createElementVNode("span", null, _toDisplayString(__props.rowItemDetail?.fundFlowDetailType === 32 ? __props.rowItemDetail?.deliverOrderNo : __props.rowItemDetail?.orderNo), 1)
                ]),
                _createElementVNode("p", _hoisted_17, [
                  _createElementVNode("span", null, _toDisplayString(_unref(t)('客户订单编号')) + "：", 1),
                  (__props.rowItemDetail?.customerOrderNo)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(__props.rowItemDetail?.customerOrderNo), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(__props.rowItemDetail?.customerBill?.customerOrderNo ?? '-'), 1))
                ]),
                _createElementVNode("p", _hoisted_20, [
                  _createElementVNode("span", null, _toDisplayString(_unref(t)('日期')) + "：", 1),
                  _createElementVNode("span", null, _toDisplayString(__props.rowItemDetail?.createTime ? _unref(getJapanTime)(__props.rowItemDetail?.createTime) : ''), 1)
                ])
              ]),
              _createElementVNode("p", _hoisted_21, [
                _createElementVNode("span", null, _toDisplayString(__props.rowItemDetail?.fundFlowDetailType === 6 ? _unref(t)('次品重买总次数') : _unref(t)('结算总数量')) + "：", 1),
                _createElementVNode("span", null, _toDisplayString(__props.rowItemDetail?.customerWalletFundFlowOrderDTO?.num ?? 0), 1)
              ]),
              _createElementVNode("p", _hoisted_22, [
                _createElementVNode("span", null, _toDisplayString(_unref(t)('结算总价')) + "：", 1),
                _createElementVNode("span", null, _toDisplayString(_unref(reducePrice)(__props.rowItemDetail?.customerWalletFundFlowOrderDTO?.money ?? 0)) + _toDisplayString(_unref(showCurrentUnit)(_unref(isKrwCurrencyCode))), 1)
              ]),
              _createElementVNode("table", _hoisted_23, [
                _createElementVNode("thead", _hoisted_24, [
                  _createElementVNode("tr", null, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(productColumns1, (item) => {
                      return _createElementVNode("th", {
                        key: item.prop,
                        width: "157"
                      }, _toDisplayString(item.label), 1)
                    }), 64))
                  ])
                ]),
                _createElementVNode("tbody", _hoisted_25, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((__props.rowItemDetail.customerWalletFundFlowOrderDTO?.customerWalletFundFlowGoodsDTOList || []), (row) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: row.productSku
                    }, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(productColumns1, (v) => {
                        return _createElementVNode("td", {
                          key: v.prop
                        }, [
                          (v.prop === 'productPropertiesName')
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList((row[v.prop] || '').split(';'), (prop) => {
                                return (_openBlock(), _createElementBlock("p", { key: prop }, _toDisplayString(prop.replace(/[+-]?\d+:[+-]?\d+:/,
                    '')), 1))
                              }), 128))
                            : (v.prop === 'productImg')
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 1,
                                  referrerPolicy: "no-referrer",
                                  src: row[v.prop],
                                  alt: "",
                                  style: {"width":"60px"}
                                }, null, 8, _hoisted_26))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                  _createTextVNode(_toDisplayString(row[v.prop]), 1)
                                ], 64))
                        ])
                      }), 64))
                    ]))
                  }), 128))
                ])
              ])
            ], 64))
          : _createCommentVNode("", true),
        ([28, 76].includes(__props.rowItemDetail?.fundFlowDetailType))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createElementVNode("div", _hoisted_27, [
                _createVNode(TableButton, {
                  title: _unref(t)('明细下载'),
                  onClick: downLoad,
                  loading: loading.value
                }, null, 8, ["title", "loading"])
              ]),
              _createVNode(STable, {
                ref: (_value, _refs) => {
                  _refs['measureRef'] = _value
                },
                columns: __props.rowItemDetail?.fundFlowDetailType === 28 ? columns : columnsRetention,
                class: "measureTable",
                "table-data": __props.rowItemDetail.feeDetailList,
                showPagination: false,
                "max-height": "400"
              }, {
                skuImg: _withCtx(({ row }) => [
                  _createVNode(ShoppingPreview, {
                    image: row.skuImg || ''
                  }, null, 8, ["image"])
                ]),
                volume: _withCtx(({ row }) => [
                  _createElementVNode("div", null, _toDisplayString((_unref(volumeMap) as any)[row.volume]), 1)
                ]),
                volumeHead: _withCtx(() => [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("span", null, _toDisplayString(_unref(t)('体积类型')), 1),
                    _createVNode(_component_el_tooltip, { effect: "light" }, {
                      content: _withCtx(() => [
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, _toDisplayString(_unref(t)('体积类型')), 1),
                          _createElementVNode("div", _hoisted_31, _toDisplayString(_unref(t)('3边合计')), 1),
                          _createElementVNode("div", null, _toDisplayString(_unref(t)('超小')), 1),
                          _hoisted_32,
                          _createElementVNode("div", null, _toDisplayString(_unref(t)('小')), 1),
                          _hoisted_33,
                          _createElementVNode("div", null, _toDisplayString(_unref(t)('中')), 1),
                          _hoisted_34,
                          _createElementVNode("div", null, _toDisplayString(_unref(t)('大')), 1),
                          _hoisted_35,
                          _createElementVNode("div", null, _toDisplayString(_unref(t)('超大')), 1),
                          _createElementVNode("div", null, "141cm" + _toDisplayString(_unref(t)('以上')), 1)
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_36, [
                          _createTextVNode(_toDisplayString(_unref(t)('详情')) + " ", 1),
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Warning))
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                settleHead: _withCtx(() => [
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("span", null, _toDisplayString(_unref(t)('单价')), 1),
                    _createVNode(_component_el_tooltip, { effect: "light" }, {
                      content: _withCtx(() => [
                        ([28].includes(__props.rowItemDetail?.fundFlowDetailType))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                              _createElementVNode("div", _hoisted_39, _toDisplayString(_unref(t)('关于超过免费保管期限的保养费')), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.rowItemDetail.priceRulesList, (i, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "flex-bwn",
                                  key: i.ruleKey
                                }, [
                                  _createElementVNode("div", null, _toDisplayString(index + 1) + "." + _toDisplayString(_unref(t)('体积类型') + (_unref(isEN)() ? ' ' : '') + i.ruleKey) + ":", 1),
                                  _createElementVNode("div", _hoisted_40, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(i?.ladderPrices, (v, vIdx) => {
                                      return (_openBlock(), _createElementBlock("div", { key: vIdx }, [
                                        (v.endNum === 999999)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(`≥${Number(v.startNum + 1)},`), 1))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(`${Number(v.startNum + 1)}~${v.endNum}${_unref(t)('天')},`), 1)),
                                        _createElementVNode("span", null, _toDisplayString(`${v.price} ${_unref(isKrwCurrencyCode) ? _unref(t)('韩元/个/天') : _unref(t)('元/个/天')}`), 1)
                                      ]))
                                    }), 128))
                                  ])
                                ]))
                              }), 128)),
                              _createElementVNode("div", _hoisted_43, _toDisplayString(_unref(t)('注: 体积为3边合计，小于1cm则按1cm计算')), 1)
                            ]))
                          : _createCommentVNode("", true),
                        ([76].includes(__props.rowItemDetail?.fundFlowDetailType))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                              _createElementVNode("div", _hoisted_45, _toDisplayString(_unref(t)('关于超过免费滞留期的滞留费')), 1),
                              _createElementVNode("div", _hoisted_46, [
                                _createElementVNode("div", null, "1." + _toDisplayString(_unref(t)('按包裹计费')) + ":", 1),
                                _createElementVNode("div", _hoisted_47, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.rowItemDetail.priceRules[0]?.ladderPrices, (i, index) => {
                                    return (_openBlock(), _createElementBlock("div", { key: index }, [
                                      (i.endNum === 999999)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString(`≥${Number(i.startNum + 1)},`), 1))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_49, _toDisplayString(`${Number(i.startNum + 1)}~${i.endNum}${_unref(t)('天')},`), 1)),
                                      _createElementVNode("span", null, _toDisplayString(`${i.price} ${_unref(isKrwCurrencyCode) ? _unref(t)('韩元/个/天') : _unref(t)('元/个/天')}`), 1)
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_50, [
                                _createElementVNode("div", null, "2." + _toDisplayString(_unref(t)('按箱子计费')) + ":", 1),
                                _createElementVNode("div", _hoisted_51, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.rowItemDetail.priceRules[1]?.ladderPrices, (i, index) => {
                                    return (_openBlock(), _createElementBlock("div", { key: index }, [
                                      (i.endNum === 999999)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString(`≥${Number(i.startNum + 1)},`), 1))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_53, _toDisplayString(`${Number(i.startNum + 1)}~${i.endNum}${_unref(t)('天')},`), 1)),
                                      _createElementVNode("span", null, _toDisplayString(`${i.price} ${_unref(isKrwCurrencyCode) ? _unref(t)('韩元/m³/天') : _unref(t)('元/m³/天')}`), 1)
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_54, [
                          _createTextVNode(_toDisplayString(_unref(t)('详情')) + " ", 1),
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Warning))
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                settlePrice: _withCtx(({ row }) => [
                  _createElementVNode("div", null, _toDisplayString(row.settlePrice) + _toDisplayString(row.pkgType === 1 ? (_unref(isKrwCurrencyCode) ? _unref(t)('韩元/m³/天') : _unref(t)('元/m³/天')) :
                (_unref(isKrwCurrencyCode) ? _unref(t)('韩元/个/天') : _unref(t)('元/个/天'))), 1)
                ]),
                pkgType: _withCtx(({ row }) => [
                  _createElementVNode("span", null, _toDisplayString(row.pkgType === 1 ? _unref(t)('$箱子$2') : row.pkgType === 0 ? _unref(t)('包裹') : '-'), 1)
                ]),
                nums: _withCtx(({ row }) => [
                  _createElementVNode("span", null, _toDisplayString(row.pkgType === 1 ? row.volume + 'm³' : row.nums + _unref(t)('个')), 1)
                ]),
                date: _withCtx(({ row }) => [
                  _createElementVNode("span", null, _toDisplayString(_unref(getJapanTime)(row.date)), 1)
                ]),
                deliverDate: _withCtx(({ row }) => [
                  _createElementVNode("span", null, _toDisplayString(_unref(getJapanTime)(row.deliverDate)), 1)
                ]),
                settleAmt: _withCtx(({ row }) => [
                  _createElementVNode("span", null, _toDisplayString(row.settleAmt) + _toDisplayString(_unref(showCurrentUnit)(_unref(isKrwCurrencyCode))), 1)
                ]),
                _: 1
              }, 8, ["columns", "table-data"])
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})